import { DropDownBox, DropDownBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../../state/standardLoanStore';
import { CUSTOM_TERM_KEY, getLoanTermOptions } from '../../../../../../../../../../../common/functions/getLoanTermOptions';
import { SetupForm } from '../../../constants/setupForm';
import { isRequiredOnceNoteDated } from '../../../functions/isRequiredOnceNoteDated';

/** Term preset for the loan type; choosing one fills in the term months ("Custom" lets them be typed in). */
export const TermDropDownField = () => {
    const setup = useStandardLoanStore((state) => state.setup);
    const selectedTermKey = useStandardLoanStore((state) => state.selectedTermKey);
    const isSubNote = useStandardLoanStore((state) => state.setupLoanContext.isSubNote);
    const selectTerm = useStandardLoanStore((state) => state.selectTerm);

    const options = setup.loanTypeId !== undefined ? getLoanTermOptions(setup.loanTypeId) : [];

    /** The term months to fill in for a term preset ("Custom" clears them for manual entry); nothing for no term. */
    const getTermMonths = (
        termKey: string
    ): Pick<SetupForm, 'initialTermMonths' | 'contractualExtension1Months' | 'contractualExtension2Months'> | undefined => {
        if (termKey === CUSTOM_TERM_KEY) {
            return {
                initialTermMonths: undefined,
                contractualExtension1Months: undefined,
                contractualExtension2Months: undefined,
            };
        }
        const option = options.find((o) => o.key === termKey);
        if (!option) {
            return undefined;
        }
        return {
            initialTermMonths: option.initialTermMonths ?? undefined,
            contractualExtension1Months: option.contractualExtension1Months ?? undefined,
            contractualExtension2Months: option.contractualExtension2Months ?? undefined,
        };
    };

    return (
        <DropDownBox
            id='setupSelectedTermKey'
            value={selectedTermKey || null}
            onChange={(termKey: string | null) => selectTerm(termKey ?? '', getTermMonths(termKey ?? ''))}
            label='Term'
            required={isRequiredOnceNoteDated(setup)}
            dataSource={options}
            displayExpr='name'
            valueExpr='key'
            placeholder='Select'
            searchEnabled={false}
            disabled={isSubNote || setup.loanTypeId === undefined}
            width='100%'
            height='36px'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
